import { PeopleFill, XCircleFill } from 'react-bootstrap-icons'
import { CustomButton } from '../../../components/CustomButton'

import { forwardRef, useCallback, useEffect, useMemo, useState } from 'react'

import apinode from '../../../services/apinode'
import { sendErrorApiMessage } from '../../../utils/sendErrorApiMessage'
import { CustomSpinner } from '../../../components/CustomSpinner'
import { toast } from 'react-toastify'
import { Form, Modal } from 'react-bootstrap'
import { Center } from '../../../components/Center'

export const ModalAdicionarUsuario = forwardRef(
  ({ isOpen, onClose, selectedInventoryId, loadInventories }) => {
    const [users, setUsers] = useState([])
    const [isLoadingUsers, setIsLoadingUsers] = useState(true)
    const [isAddUserLoading, setIsAddUserLoading] = useState(false)
    const [searchUser, setSearchUser] = useState('')

    const filteredUsers = useMemo(() => {
      return users.filter((user) =>
        user.nomefuncionario.toLowerCase().includes(searchUser.toLowerCase()),
      )
    }, [searchUser, users])

    async function handleAddUsers() {
      try {
        setIsAddUserLoading(true)

        await apinode.post(
          `/inventario/users/${selectedInventoryId}/${localStorage.idconta}`,
          {
            users,
          },
        )

        toast.success('Usuário adicionado com sucesso!')
        loadInventories()
      } catch (error) {
        sendErrorApiMessage(
          err,
          'Não foi possível adicionar usuários ao inventário!',
        )
      } finally {
        setIsAddUserLoading(false)
        onClose()
      }
    }

    function handleSelectUser(userId) {
      const index = users.findIndex((user) => user.idfuncionario === userId)
      const user = users[index]

      if (user.idinventario) {
        setUsers((prevState) =>
          prevState.with(index, {
            ...user,
            idinventario: null,
          }),
        )
      } else {
        setUsers((prevState) =>
          prevState.with(index, {
            ...user,
            idinventario: selectedInventoryId,
          }),
        )
      }
    }

    const loadUsers = useCallback(async () => {
      try {
        setIsLoadingUsers(true)

        const response = await apinode.get(
          `/inventario/users/${selectedInventoryId}/${localStorage.idconta}`,
        )

        setUsers(response.data)
      } catch (error) {
        console.error('Erro ao buscar usuários:', error)
      } finally {
        setIsLoadingUsers(false)
      }
    }, [selectedInventoryId])

    useEffect(() => {
      loadUsers()
    }, [loadUsers])

    return (
      <Modal
        show={isOpen}
        onHide={onClose}
        centered
        dialogClassName="custom-modalzpl"
      >
        <Modal.Header>
          <Modal.Title>Adicionar Usuários ao Inventário</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {isLoadingUsers ? (
            <Center>
              <CustomSpinner />
            </Center>
          ) : (
            <>
              <Form.Control
                value={searchUser}
                onChange={(e) => setSearchUser(e.target.value)}
                placeholder="Digite o nome do usuário"
                style={{
                  marginBottom: 30,
                }}
              />

              {filteredUsers.map((user) => {
                const isChecked = !!user.idinventario

                return (
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: 10,
                      marginBottom: 10,
                    }}
                  >
                    <Form.Check
                      key={user.idfuncionario}
                      checked={isChecked}
                      onChange={() => handleSelectUser(user.idfuncionario)}
                    />

                    <span>{String(user.nomefuncionario).toUpperCase()}</span>
                  </div>
                )
              })}
            </>
          )}
        </Modal.Body>

        <Modal.Footer>
          <CustomButton
            title="Fechar"
            color="#ff0000"
            onClick={onClose}
          >
            <XCircleFill />
          </CustomButton>

          <CustomButton
            title="Adicionar Usuários"
            color="#229954"
            onClick={handleAddUsers}
            isDisabled={users.length === 0 || isLoadingUsers}
            isLoading={isAddUserLoading}
            isLoadingText="Adicionando..."
          >
            <PeopleFill />
          </CustomButton>
        </Modal.Footer>
      </Modal>
    )
  },
)
